var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _vm._l(_vm.actualDates, function (dateRecord, index) {
        return _c(
          "div",
          { staticClass: "flex" },
          [
            _c("div", [
              _c(
                "select",
                {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: dateRecord.monthSelected,
                      expression: "dateRecord.monthSelected",
                    },
                  ],
                  staticClass: "form-control",
                  attrs: { disabled: dateRecord.toRemove },
                  on: {
                    change: [
                      function ($event) {
                        var $$selectedVal = Array.prototype.filter
                          .call($event.target.options, function (o) {
                            return o.selected
                          })
                          .map(function (o) {
                            var val = "_value" in o ? o._value : o.value
                            return val
                          })
                        _vm.$set(
                          dateRecord,
                          "monthSelected",
                          $event.target.multiple
                            ? $$selectedVal
                            : $$selectedVal[0]
                        )
                      },
                      function ($event) {
                        return _vm.updateActualDate(index)
                      },
                    ],
                  },
                },
                _vm._l(12, function (ind) {
                  return _c("option", { key: ind, domProps: { value: ind } }, [
                    _vm._v(_vm._s(ind < 10 ? "0" + ind : ind)),
                  ])
                }),
                0
              ),
            ]),
            _vm._v(" "),
            _c("div", [
              _c(
                "select",
                {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: dateRecord.yearSelected,
                      expression: "dateRecord.yearSelected",
                    },
                  ],
                  staticClass: "form-control",
                  attrs: { disabled: dateRecord.toRemove },
                  on: {
                    change: [
                      function ($event) {
                        var $$selectedVal = Array.prototype.filter
                          .call($event.target.options, function (o) {
                            return o.selected
                          })
                          .map(function (o) {
                            var val = "_value" in o ? o._value : o.value
                            return val
                          })
                        _vm.$set(
                          dateRecord,
                          "yearSelected",
                          $event.target.multiple
                            ? $$selectedVal
                            : $$selectedVal[0]
                        )
                      },
                      function ($event) {
                        return _vm.updateActualDate(index)
                      },
                    ],
                  },
                },
                _vm._l(_vm.yearsRange, function (year) {
                  return _c(
                    "option",
                    { key: year, domProps: { value: year } },
                    [_vm._v(_vm._s(year))]
                  )
                }),
                0
              ),
            ]),
            _vm._v(" "),
            !_vm.componentOptions?.hide?.tillPart
              ? [
                  _vm._m(0, true),
                  _vm._v(" "),
                  _c(
                    "div",
                    [
                      _c("input", {
                        directives: [
                          {
                            name: "validate",
                            rawName: "v-validate",
                            value: "date_format:dd.MM.yyyy",
                            expression: "'date_format:dd.MM.yyyy'",
                          },
                          {
                            name: "model",
                            rawName: "v-model",
                            value: dateRecord.actual_date,
                            expression: "dateRecord.actual_date",
                          },
                        ],
                        staticClass: "form-control opacity",
                        attrs: {
                          type: "text",
                          name: `validDate_${index}`,
                          disabled: dateRecord.toRemove,
                          placeholder: "Дата",
                          "data-vv-as": "Дата",
                        },
                        domProps: { value: dateRecord.actual_date },
                        on: {
                          input: function ($event) {
                            if ($event.target.composing) return
                            _vm.$set(
                              dateRecord,
                              "actual_date",
                              $event.target.value
                            )
                          },
                        },
                      }),
                      _vm._v(" "),
                      _vm.errors.has(`validDate_${index}`)
                        ? _c(
                            "small",
                            { staticClass: "form-text text-danger" },
                            [
                              _vm._v(
                                "\n          " +
                                  _vm._s(
                                    _vm.errors.first(`validDate_${index}`)
                                  ) +
                                  "\n        "
                              ),
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c("datepicker", {
                        ref: "calendar",
                        refInFor: true,
                        attrs: {
                          value: _vm.getProperDate(dateRecord.actual_date),
                          language: _vm.locality,
                          "monday-first": true,
                          "input-class": "form-control hidden",
                          format: "dd.MMM.yyyy",
                        },
                        on: {
                          change: (e) => _vm.dateSelected(e, index),
                          selected: (e) => _vm.dateSelected(e, index),
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("div", [
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-info calendarAction opacity",
                        attrs: {
                          disabled: dateRecord.toRemove,
                          type: "button",
                        },
                        on: {
                          click: function ($event) {
                            return _vm.openCalendar(index)
                          },
                        },
                      },
                      [
                        _c("i", {
                          staticClass:
                            "icon-fa icon-fa-calendar calendarAction",
                        }),
                      ]
                    ),
                  ]),
                  _vm._v(" "),
                  _c("div", [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: dateRecord.comment,
                          expression: "dateRecord.comment",
                        },
                      ],
                      staticClass: "form-control",
                      attrs: { type: "text", placeholder: "Комментарий" },
                      domProps: { value: dateRecord.comment },
                      on: {
                        input: function ($event) {
                          if ($event.target.composing) return
                          _vm.$set(dateRecord, "comment", $event.target.value)
                        },
                      },
                    }),
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "checkbox_div" },
                    [
                      !dateRecord.is_active && dateRecord.status === 2
                        ? [_c("label", [_vm._v("ожидается в поступлении")])]
                        : [
                            _c("label", { staticClass: "pointer" }, [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: dateRecord.info_only,
                                    expression: "dateRecord.info_only",
                                  },
                                ],
                                attrs: { type: "checkbox" },
                                domProps: {
                                  checked: Array.isArray(dateRecord.info_only)
                                    ? _vm._i(dateRecord.info_only, null) > -1
                                    : dateRecord.info_only,
                                },
                                on: {
                                  change: function ($event) {
                                    var $$a = dateRecord.info_only,
                                      $$el = $event.target,
                                      $$c = $$el.checked ? true : false
                                    if (Array.isArray($$a)) {
                                      var $$v = null,
                                        $$i = _vm._i($$a, $$v)
                                      if ($$el.checked) {
                                        $$i < 0 &&
                                          _vm.$set(
                                            dateRecord,
                                            "info_only",
                                            $$a.concat([$$v])
                                          )
                                      } else {
                                        $$i > -1 &&
                                          _vm.$set(
                                            dateRecord,
                                            "info_only",
                                            $$a
                                              .slice(0, $$i)
                                              .concat($$a.slice($$i + 1))
                                          )
                                      }
                                    } else {
                                      _vm.$set(dateRecord, "info_only", $$c)
                                    }
                                  },
                                },
                              }),
                              _vm._v(" не выгружать на сайты"),
                            ]),
                          ],
                    ],
                    2
                  ),
                ]
              : _vm._e(),
            _vm._v(" "),
            _c("div", [
              _c(
                "button",
                {
                  staticClass: "btn btn-outline-danger",
                  attrs: { type: "button" },
                  on: {
                    click: function ($event) {
                      return _vm.removeRecord(index)
                    },
                  },
                },
                [_c("i", { staticClass: "icon-fa icon-fa-remove" })]
              ),
            ]),
          ],
          2
        )
      }),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "text-right" },
        [
          _c(
            "button",
            {
              staticClass: "btn btn-sm btn-outline-info m-1",
              on: { click: _vm.addNewRecord },
            },
            [_vm._v("Добавить")]
          ),
          _vm._v(" "),
          _c(
            "vue-ladda",
            {
              attrs: {
                "button-class": "btn btn-success btn-sm ladda-button",
                "data-style": "zoom-in",
                loading: _vm.btnLoading,
              },
              on: {
                click: function ($event) {
                  return _vm.updateDates()
                },
              },
            },
            [_vm._v("Сохранить\n    ")]
          ),
        ],
        1
      ),
    ],
    2
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", [
      _c("span", { staticClass: "text_between" }, [_vm._v("до")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }